import React from "react";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

const RiskIndicator = ({ riskLevel }) => {
  const getRiskColor = () => {
    switch (riskLevel.status) {
      case "high":
        return "#FF0000";
      case "medium":
        return "#FFA500";
      case "low":
        return "#FFD700";
      default:
        return "#808080";
    }
  };

  return (
    <div className="risk-indicator">
      <Tooltip title={riskLevel.label} placement="top">
        <div
          className="risk-dot"
          style={{
            backgroundColor: getRiskColor(),
          }}
        />
      </Tooltip>
    </div>
  );
};

RiskIndicator.propTypes = {
  riskLevel: PropTypes.shape({
    status: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string,
  }).isRequired,
};

export default RiskIndicator;
